/**
 * The progress of a TRM's conversion into playable audio
 */
export var TrmConversionStatus;
(function (TrmConversionStatus) {
    TrmConversionStatus["NotStarted"] = "not started";
    TrmConversionStatus["InProgress"] = "in progress";
    TrmConversionStatus["Complete"] = "complete";
    TrmConversionStatus["Failed"] = "failed";
})(TrmConversionStatus || (TrmConversionStatus = {}));
